module.exports = __webpack_public_path__ + "img/PL08273.c84d1765.png";